import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
} from "@material-ui/core";

const PopupBlockedDialog = ({ onCloseAction }) => {
  const [showModal, setShowModal] = useState(true);
  const onClose = () => {
    setShowModal(false);
    if (typeof onCloseAction !== "undefined") {
      onCloseAction();
    }
  };

  return (
    <Dialog
      open={showModal}
      onClose={onClose}
      onBackdropClick={onClose}
      onEscapeKeyDown={onClose}
      PaperProps={{
        style: {
          backgroundColor: "#A00",
        },
      }}
    >
      <DialogContent>
        <DialogContentText>
          <Typography style={{ color: "#FFF" }}>
            It looks like pop-up blocker is enabled on your browser. Please download the file
            instead.
          </Typography>
        </DialogContentText>
        <DialogActions>
          <Button
            variant="contained"
            autoFocus
            onClick={onClose}
            color="primary"
            style={{ fontWeight: "bold" }}
          >
            Close
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

PopupBlockedDialog.propTypes = {
  onCloseAction: PropTypes.func,
};

export default PopupBlockedDialog;
